// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__36RmJ","paramInput":"JobSimulator_paramInput__3Cw5B","input":"JobSimulator_input__2ZzMQ"};